import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';

class NetworkPointDetailsSurrenderCtrl implements ng.IController {
    public networkPoint: NetworkPointDto;
    public uiLoadingSurrenders: boolean = true;
    public surrenders: any = [];
    public surrenderCapacitiesSortAscending = true;
    public surrenderCapacitiesSortColumn = 'runtimeStart';
    public paginator = {
        identificationName: 'surrenders',
        itemsPerPage: 10,
        start: 0
    };

    constructor(
        private Surrender,
        private errorHandler: ErrorHandler,
        public DATES
    ) {}

    $onInit(): void {
        this.getSurrender();
    }

    public getSurrender() {
        this.uiLoadingSurrenders = true;

        let param = {
            networkPoint: this.networkPoint.id,
            pageSize: this.paginator.itemsPerPage,
            start: this.paginator.start,
            sortColumn: this.surrenderCapacitiesSortColumn,
            sortAscending: this.surrenderCapacitiesSortAscending
        };

        this.Surrender.getSurrenderRequests(
            param,
            (res) => {
                this.surrenders = res;
                this.uiLoadingSurrenders = false;
            },
            this.errorHandler
        );
    }

    public setSurrenderCapacitySortBy(value) {
        this.surrenderCapacitiesSortAscending = !(
            this.surrenderCapacitiesSortAscending &&
            this.surrenderCapacitiesSortColumn == value
        );
        this.surrenderCapacitiesSortColumn = value;
        this.getSurrender();
    }

    /**
     * Certain functionality is not available for cubic meter per hour configured network points.
     */
    public hasCubicMeterPerHourConfigured() {
        return this.networkPoint.physicalUnit === 'M3_H';
    }

    public changePage(newPageNumber) {
        let newPaginatorStart =
            (newPageNumber - 1) * this.paginator.itemsPerPage;
        if (this.paginator.start !== newPaginatorStart) {
            this.paginator.start = newPaginatorStart;
            this.getSurrender();
        }
    }
}

angular.module('app').component('pkpNetworkPointDetailsSurrender', {
    controller: NetworkPointDetailsSurrenderCtrl,
    template:
        require('app/network-point/network-point-details-surrender.component.html'),
    bindings: {
        networkPoint: '<'
    }
});
